export class RequestNewMiPlayerIdEvent extends Event {

  videoId: string | undefined

  constructor (videoId: string | undefined) {
    super('RequestNewMiPlayerId')
    this.videoId = videoId
  }
}
